/**
 * @author Kelnik
 *
 * FullSlider - Слайдер открывающийся в весь размер экрана
 */

import 'slick-carousel/slick/slick.css';
import 'slick-carousel';
import tmplMain from './full-slider.twig';
import TouchZoom from 'components/touch-zoom';
import Utils from 'common/scripts/utils';

class FullSlider {
    constructor(options) {
        this.options = options;

        this.containerClass = 'j-full-slider full-slider';
        this.closeSelector = '.j-full-slider-close';
        this.prevSelector = '.j-full-slider-prev';
        this.nextSelector = '.j-full-slider-next';
        this.trackSelector = '.j-full-slider-track';

        this.elements = [];
        this.slider = null;
        this.touchZooms = [];
    }

    toOpen(data = {}) {
        this.elements = this._prettyElements(data.elements);

        this._createTemplate();
        this._initElements();
        this._bindEvents();
        this._initSlick();
    }

    _prettyElements(elements) {
        return elements.map((element) => {
            const sources = Array.from(element.querySelectorAll('source'));
            const img = element.querySelector('img');
            const loader = element.querySelector('.loader');

            // eslint-disable-next-line no-unused-expressions
            loader && Utils.removeElement(loader);

            element.className = 'loaded loading';

            if (sources && sources.length) {
                sources.forEach((source) => {
                    if (source.dataset.srcset) {
                        source.setAttribute('srcset', source.dataset.srcset);
                        source.className = 'loaded';
                    }
                });
            }

            if (img && img.dataset.src) {
                img.setAttribute('src', img.dataset.src);
                img.className = 'loaded';
            }

            return element.outerHTML;
        });
    }

    _createTemplate() {
        this.container = document.createElement('div');
        this.container.className = this.containerClass;
        this.container.insertAdjacentHTML('beforeend', tmplMain({elements: this.elements}));

        document.body.insertAdjacentElement('beforeend', this.container);

        Utils.bodyFixed(this.container);
    }

    _initElements() {
        this.close = this.container.querySelector(this.closeSelector);
        this.prev = this.container.querySelector(this.prevSelector);
        this.next = this.container.querySelector(this.nextSelector);
        this.track = this.container.querySelector(this.trackSelector);
    }

    _bindEvents() {
        // eslint-disable-next-line no-unused-expressions
        this.close && this.close.addEventListener('click', this.toClose.bind(this));

        window.addEventListener('resize', () => {
            if (this.container && window.innerWidth >= 960) {
                this.toClose();
            }
        });

        window.addEventListener('orientationchange', this._toggleTouchZooms.bind(this));
    }

    _toggleTouchZooms(event) {
        this.touchZooms.forEach((touchZoom) => {
            const isPortrait = this._checkIsPortrait(event.target.screen);

            this._toggleAbleZoom(touchZoom, isPortrait);
        });
    }

    _checkIsPortrait(screen) {
        if (!screen.orientation) {
            return false;
        }

        return screen.orientation.type.includes('portrait');
    }

    _toggleAbleZoom(touchZoom, isPortrait) {
        const method = isPortrait ? 'disablePinch' : 'enablePinch';

        touchZoom[method]();
    }

    _initSlick() {
        this.slider = $(this.track);

        this.slider.on('init', (event, slick) => {
            slick.$slides.each((index, $slide) => {
                this.initTouchZoom($slide.querySelector('.full-slider__slide'));
            });
        });

        this.slider.on('beforeChange', () => {
            this.touchZooms.forEach((touchZoom) => {
                if (touchZoom.wrapper.classList.contains('slick-current')) {
                    touchZoom.updateScaleValue();
                }
            });
        });

        this.slider.slick({
            lazyLoad      : 'ondemand',
            infinite      : true,
            slidesToShow  : 1,
            slidesToScroll: 1,
            speed         : 300,
            adaptiveHeight: false,
            prevArrow     : this.prev,
            nextArrow     : this.next
        });
    }

    initTouchZoom(element) {
        const isMobilePortrait = window.matchMedia('(max-width: 500px)').matches;
        const touchZoom = new TouchZoom({target: element});

        touchZoom.bindEvent();
        if (isMobilePortrait || this._checkIsPortrait(window.screen)) {
            touchZoom.disablePinch();
        }
        this.touchZooms.push(touchZoom);
    }

    toClose() {
        if (this.slider) {
            this.slider.slick('unslick');
        }

        Utils.removeElement(this.container);
        Utils.bodyStatic();

        delete this.container;
    }
}

export default FullSlider;
